<div class="container text-white">
  <div class="py-[64px] slg:py-[220px] slg:max-w-max smd:max-w-[400px] md:max-w-[550px] mx-auto slg:mx-0">
    <h1 class="text-pretty text-3xl smd:text-4xl xl:text-5xl font-700 mb-6 smd:mb-8" data-test="top-page-categorie__title">
      {{ data.title }}
    </h1>
    <span class="block w-[60px] slg:w-[100px] h-[8px] slg:h-[12px] bg-secondary-color mb-8"></span>
    <nscf-rte class="font-300 text-lg" [data]="data.description" />
    @if (data.ctaUrl && data.ctaLabel) {
      <nscf-cta-button centered class="cta-button w-full" [text]="data.ctaLabel" [ctaUrl]="data.ctaUrl" />
    }
    @if (data.trustpilot) {
      <div class="mt-8">
        <nscf-trustpilot-micro-star theme="dark"></nscf-trustpilot-micro-star>
      </div>
    }
  </div>
</div>
@if (isMobileOrTablet() === false) {
  <div class="absolute top-0 bottom-0 py-[160px] right-0 max-h-full rounded-tl-xl rounded-bl-xl">
    <img
      [src]="data.image?.url"
      [attr.width]="imageWidth"
      fetchPriority="high"
      [alt]="data.image?.alt"
      class="h-full object-cover slg:rounded-l-md"
    />
  </div>
}
